import React, { useRef, useState, useEffect } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

const scrollContainerStyle = {
  height: '100vh',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
};

export default function ParallaxScrollWrapper({ children }) {
  const scrollRef = useRef(null);
  const [scrollContainer, setScrollContainer] = useState(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el?.isConnected) {
      setScrollContainer(el);
    }
  }, []);

  return (
    <div
      ref={scrollRef}
      className="app-scroll-container"
      style={scrollContainerStyle}
    >
      {scrollContainer && (
        <ParallaxProvider scrollContainer={scrollContainer}>
          {children}
        </ParallaxProvider>
      )}
    </div>
  );
}
